import * as React from 'react';
const IconExternal = ({ size = 24, color = 'currentColor' }) => (
  <svg
    viewBox="0 0 48 48"
    width={size}
    height={size}
    fill={color}
    xmlns="http://www.w3.org/2000/svg">
    <title>Website</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="invisible_box" data-name="invisible box">
        <rect width={48} height={48} fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2">
        <path d="M28,4a2,2,0,0,0-2,2.3A2.1,2.1,0,0,0,28.1,8h9.1L24.7,20.5a2,2,0,0,0-.2,2.8A1.8,1.8,0,0,0,26,24a2,2,0,0,0,1.4-.6L40,10.8v9.1A2.1,2.1,0,0,0,41.7,22,2,2,0,0,0,44,20V6a2,2,0,0,0-2-2Z" />
        <path d="M41.7,30A2.1,2.1,0,0,0,40,32.1V40H8V8h8a2,2,0,0,0,2-2.3A2.1,2.1,0,0,0,15.9,4H6A2,2,0,0,0,4,6V42a2,2,0,0,0,2,2H42a2,2,0,0,0,2-2V32A2,2,0,0,0,41.7,30Z" />
      </g>
    </g>
  </svg>
);
export default IconExternal;
